import { useEffect, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import config from '../../../config';
import { DEFAULT_FILTERS, loadFiltersFromLocalStorage, normalizeFilters, resolveMeetFilters } from '../utils/filters';

export const useFilters = () => {
  const axiosPrivate = useAxiosPrivate();

  const [filters, setFilters] = useState(() => {
    const savedFilters = loadFiltersFromLocalStorage();
    return savedFilters ? normalizeFilters(savedFilters) : null;
  });

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchFilters = async () => {
    const savedFilters = loadFiltersFromLocalStorage();

    try {
      const profileRes = await axiosPrivate.get(config.API.USERS.PROFILE);
      const me = profileRes.data?.data || profileRes.data;

      if (me) {
        const resolvedFilters = resolveMeetFilters(me, savedFilters);

        setFilters(resolvedFilters);

        console.log('📋 Используем фильтры из профиля пользователя:', resolvedFilters);
      } else {
        console.log('📋 Профиль пуст — используем дефолтные фильтры:', filters);
      }
    } catch (profileErr) {
      console.warn('❌ Не удалось получить профиль для дефолтных фильтров:', profileErr);
      const fallbackFilters = savedFilters ? normalizeFilters(savedFilters) : DEFAULT_FILTERS;
      setFilters(fallbackFilters);
      console.log('📋 Используем фильтры по умолчанию:', fallbackFilters);
    }
  };

  return { filters, filtersCount: filters ? Object.keys(filters).length : 0 };
};
